import { isEmpty } from 'lodash';
import queryString from 'query-string';
import { SetQueryStringParams } from './setQueryString.types';

const setQueryString = (params: SetQueryStringParams) => {
  const { isNewMD = false, navigate, paramName, paramValue, pathname, searchParams, shouldPushPath = false } = params;

  const parsedQuery = queryString.parse(searchParams);

  parsedQuery[paramName] = paramValue;

  // If the param value is empty, we remove it from the query string
  if (isEmpty(paramValue)) {
    delete parsedQuery[paramName];
  }

  // When we create a new MD, we remove the old URL param while the new one is in the process of being set and selected in the dropdown
  if (isNewMD) {
    delete parsedQuery.version;
  }

  const newPath = {
    pathname,
    search: queryString.stringify(parsedQuery),
  };

  if (shouldPushPath) {
    return navigate(newPath);
  }

  return navigate(newPath, { replace: true });
};

export default setQueryString;
